import { assignInlineVars } from '@vanilla-extract/dynamic';

import { colors } from '../../colors';

import { spinnerColor, spinner, spinnerWrapper } from './Spinner.css';

export type SpinnerProps = {
    size: 's' | 'm' | 'l';
    isAbsolute?: boolean;
    color?: string;
};

export function Spinner({ size = 's', isAbsolute = false, color = colors.blue[500] }: SpinnerProps) {
    return (
        <div className={spinnerWrapper({ isAbsolute })}>
            <span
                className={spinner({ size })}
                style={assignInlineVars({
                    [spinnerColor]: color,
                })}
            />
        </div>
    );
}
